import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MobileService } from '@shared/services/mobile.service';

@Component({
  selector: 'rav-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent implements OnInit {
  formGroup: FormGroup;
  emptySearch = false;
  isSearchOpen = false;

  constructor(public mobile: MobileService, public router: Router, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.formGroup = this.formBuilder.group({ search: new FormControl('', Validators.required) });
  }

  submitSearch(searchString: string) {
    if (searchString === '') {
      this.emptySearch = true;
      return;
    }
    this.emptySearch = false;
    this.router.navigate(['/search', searchString]);
  }
}
